(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientOrderTestDeleteNewController',PatientOrderTestDeleteNewController);

    PatientOrderTestDeleteNewController.$inject = ['$uibModalInstance', 'entity'];

    function PatientOrderTestDeleteNewController($uibModalInstance, entity) {
        var vm = this;

        vm.patientOrderTest = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            $uibModalInstance.close({id: id});
        }
    }
})();
